import React from 'react';
import {Platform, View, StyleSheet} from 'react-native';
import {Form} from '../../../../../../shared/components/form';
import {Field} from 'redux-form';
import {Button} from '../../../../../../shared/components/button';
import {useTheme} from '../../../../../../shared/theme';
import {defaults} from '../../../../../../shared/constants/defaults';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../../../shared/theme/helpers';
import {BaseField} from '../../../../../../shared/components/baseField';

export interface Props {
  onSubmit: (e?: any) => void;
}

export function InputFormView(props: Props) {
  const {onSubmit} = props;
  const theme = useTheme();
  const identificatorNormalize = (value: any) => {
    const res = (value as string)?.replace(/ /g, '').substring(0, defaults.maxLoginLength);
    return res;
  };
  const styles = useStyles(({mediaOnly, mediaExclude, platformOnly}) => {
    return {
      innerButton: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: theme.color.primaryColor,
      },
      textInnerContainer: theme.fonts.bodySmall,
      container: StyleSheet.flatten([
        {
          height: 200,
          flexGrow: 1,
          flexShrink: 0,
        },
        mediaOnly(
          DeviceSize.desktop,
          {width: 300, marginTop: 24},
          {width: Platform.OS === 'web' ? 260 : 284, paddingTop: 18},
        ),
      ]),
      fieldContainer: {
        marginBottom: 30,
        ...mediaExclude(DeviceSize.desktop, {marginTop: 5}),
      },
      buttonWrapper: {
        marginTop: 10,
      },
      button: StyleSheet.flatten([
        {
          alignSelf: 'center',
          marginTop: 'auto',
          marginBottom: 0,
        },
        mediaOnly(DeviceSize.desktop, {width: 300}, {width: '100%'}),
      ]),
      cardFieldStyle: platformOnly('web', {marginBottom: 45, marginTop: 24}, {}),
    };
  });

  return (
    <Form style={styles.container} onSubmit={onSubmit}>
      <View style={styles.fieldContainer}>
        <Field
          component={BaseField}
          label={`Номер карты ЕСК или СНИЛС`}
          type='digits'
          name='identificator'
          required
          disabled={false}
          onSubmitEditing={onSubmit}
          autoFocus={Platform.OS !== 'ios'}
          normalize={identificatorNormalize}
        />
      </View>
      <View style={styles.buttonWrapper}>
        <Button
          id='login-enter-next'
          type='secondary'
          style={styles.button}
          onPress={onSubmit}
          iconProps={{width: 16, height: 19}}
          text='Привязать'
        />
      </View>
    </Form>
  );
}
